var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-center"},[_c('h3',[_vm._v(_vm._s(_vm.tr('title')))]),_c('div',{staticClass:"text-left mt-8",domProps:{"innerHTML":_vm._s(_vm.$marked(_vm.content))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }